<div class="addp-form-container">
  <div class="loading-shade" *ngIf="loading">
    <p>Loading company information…</p>
  </div>

  <ng-container *ngIf="hasDetails; else missingDetails">
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="form-section">
        <h3>1. Informations</h3>
        <div class="quote-info-grid">
          <!--
          <div class="field full-width">
            <label>Quote Name</label>
            <div class="static-value">{{ quoteName }}</div>
          </div>
          -->

          <!--
          <div class="field">
            <label>Type</label>
            <div class="static-value">Supplemental</div>
          </div>
          -->

          <div class="field">
            <label>McKay Entity</label>
            <div class="static-value">{{ form.get('mckayEntity')?.value || '—' }}</div>
          </div>

          <div class="field">
            <label>MSA</label>
            <div class="static-value">{{ msaDisplayValue }}</div>
          </div>

          <div class="field">
            <label>Client</label>
            <div class="static-value">{{ companyName }}</div>
          </div>

          <!--
          <div class="field">
            <label>Internal Status</label>
            <div class="static-value">Creation</div>
          </div>
          -->

          <!--
          <div class="field">
            <label>Contract Sent Date</label>
            <div class="static-value">&nbsp;/&nbsp;/</div>
          </div>
          -->

          <div class="field">
            <label>Service</label>
            <div class="static-value">{{ serviceLabel }}</div>
          </div>

          <!--
          <div class="field">
            <label>QRD Area</label>
            <div class="static-value">&nbsp;-</div>
          </div>
          -->

          <!--
          <div class="field">
            <label>Contract Version</label>
            <div class="static-value">v1.1 ADDP</div>
          </div>
          -->

          <div class="field hidden">
            <label>ADDP</label>
            <div class="static-value">
              <input type="checkbox" checked disabled>
            </div>
          </div>

          <div class="field">
            <label>Currency</label>
            <div class="static-value">{{ form.get('currency')?.value || '—' }}</div>
          </div>

          <div class="field">
            <label>Billing Account</label>
            <ng-container *ngIf="billingAccounts.length > 0; else noBillingAccounts">
              <select formControlName="billingAccount">
                <option [ngValue]="null">-- Select --</option>
                <option *ngFor="let account of billingAccounts" [ngValue]="account">
                  {{ account.name }}
                </option>
              </select>
            </ng-container>
          </div>
          <ng-template #noBillingAccounts>
            <div class="warning-text">No billing account available.</div>
          </ng-template>
        </div>
      </div>

      <div class="form-section price-section">
        <h3>2. Price</h3>
        <div class="price-row">
          <div class="price-label">Monthly Recurring Cost:</div>
          <div class="price-value">
            <ng-container *ngIf="pricingLoading">Loading price…</ng-container>
            <ng-container *ngIf="!pricingLoading && pricingQuote">{{ formattedRecurringCost }}</ng-container>
            <ng-container *ngIf="!pricingLoading && !pricingQuote && pricingError">{{ pricingError }}</ng-container>
            <ng-container *ngIf="!pricingLoading && !pricingQuote && !pricingError">—</ng-container>
          </div>
        </div>
        <p class="price-note">You'll be invoiced quarterly &lt;legal infos to come&gt;</p>
      </div>

      <div class="form-section contacts-section" formGroupName="contacts">
        <h3>3. Contact Informations</h3>
        <div *ngIf="isCompanySelectedMode" class="contact-info-banner">
          {{ companySelectedModeNotice }}
        </div>

        <div class="contact-block">
          <h4>{{ primaryContactHeading }}</h4>
          <div class="row" formGroupName="primary">
            <div class="field" [class.field--invalid]="isFieldInvalid('contacts.primary.name')">
              <label>Name</label>
              <input type="text" formControlName="name">
              <div class="field-error" *ngIf="getFieldError('contacts.primary.name') as error">{{ error }}</div>
            </div>
            <div class="field" [class.field--invalid]="isFieldInvalid('contacts.primary.email')">
              <label>Email</label>
              <input type="email" formControlName="email">
              <div class="field-error" *ngIf="getFieldError('contacts.primary.email') as error">{{ error }}</div>
            </div>
            <div class="field">
              <label>Phone (optional)</label>
              <input type="tel" formControlName="phone">
            </div>
          </div>
        </div>

        <div class="contact-block">
          <h4>Technical Contact</h4>
          <div class="row" formGroupName="technical">
            <div class="field"><label>Name</label><input type="text" formControlName="name"></div>
            <div class="field"><label>Email</label><input type="email" formControlName="email"></div>
            <div class="field"><label>Phone</label><input type="tel" formControlName="phone"></div>
          </div>
        </div>

        <div class="contact-block">
          <h4>Network Notification Contact</h4>
          <div class="row" formGroupName="networkNotification">
            <div class="field"><label>Name</label><input type="text" formControlName="name"></div>
            <div class="field"><label>Email</label><input type="email" formControlName="email"></div>
            <div class="field"><label>Phone</label><input type="tel" formControlName="phone"></div>
          </div>
        </div>

        <div class="contact-block">
          <h4>Billing Contact</h4>
          <div class="row" formGroupName="billing">
            <div class="field"><label>Name</label><input type="text" formControlName="name"></div>
            <div class="field"><label>Email</label><input type="email" formControlName="email"></div>
            <div class="field"><label>Phone</label><input type="tel" formControlName="phone"></div>
          </div>
        </div>

        <div class="contact-block">
          <h4>Data Usage Reporting Contact</h4>
          <div class="row" formGroupName="dataUsageReporting">
            <div class="field"><label>Name</label><input type="text" formControlName="name"></div>
            <div class="field"><label>Email</label><input type="email" formControlName="email"></div>
            <div class="field"><label>Phone</label><input type="tel" formControlName="phone"></div>
          </div>
        </div>
      </div>

      <div class="form-section">
        <h3>4. Client Connection Points</h3>
        <div class="connection-points-table-wrapper">
          <table class="connection-points-table">
            <thead>
              <tr>
                <th>Co-Location Site(s)</th>
                <th>Technical POP</th>
                <th>Self-Hosted</th>
                <th>Third Party Host Account</th>
                <th>Third Party Host Contact</th>
                <th>Third Party Host Email</th>
                <th>Encrypted</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ colocationSite }}</td>
                <td>{{ technicalPop }}</td>
                <td>{{ isSelfHosted }}</td>
                <td>{{ thirdPartyHostAccount || '—' }}</td>
                <td>&nbsp;</td>
                <td>&nbsp;</td>
                <td>{{ isEncrypted }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="form-section">
        <h3>5. Available Products</h3>
        <ul class="product-list">
          <li *ngFor="let item of selectedItems">
            <strong>{{ item.product?.name || 'Product' }}</strong>
            <span class="muted">({{ item.product?.carrier || 'N/A' }})</span>
          </li>
        </ul>
      </div>

      <div class="form-section">
        <h3>6. Comments</h3>
        <div *ngIf="isCompanySelectedMode" class="comments-info-banner">
          These comments are not for internal use; they will be visible to the customer.
        </div>        
        <div class="comments-field">
          <textarea formControlName="comments" placeholder="Additional comments..."></textarea>
        </div>
      </div>

      <footer class="form-actions">
        <button type="button" class="cancel-btn" (click)="onCancel()">Cancel</button>
        <button type="submit" class="submit-btn" [disabled]="form.invalid || !companyDetails || submitting">
          {{ submitLabel }}
        </button>
      </footer>
    </form>
  </ng-container>

  <ng-template #missingDetails>
    <div class="placeholder">
      <p *ngIf="!loading">No company details available for this request.</p>
    </div>
  </ng-template>
</div>
